import React, { useCallback, useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { BadgeCheck, X } from 'lucide-react';
const NAMES = ['Valentina G.', 'Matías R.', 'Camila F.', 'Juan Cruz P.', 'Sofía M.', 'Tomás L.', 'Martina S.', 'Lucas D.', 'Julieta A.', 'Franco B.', 'Agustina V.', 'Nicolás T.', 'Micaela C.', 'Santiago E.', 'Florencia R.', 'Joaquín M.', 'Brenda O.', 'Ignacio F.', 'Rocío N.', 'Federico H.'];
const CITIES = ['Buenos Aires', 'Córdoba', 'Rosario', 'La Plata', 'Mendoza', 'Mar del Plata', 'San Miguel de Tucumán', 'Salta', 'Santa Fe', 'Neuquén', 'Resistencia', 'Bahía Blanca', 'Corrientes', 'Posadas', 'San Juan', 'Paraná'];
const PACKS = [{
  name: 'Pack Inicial',
  price: '$19.990'
}, {
  name: 'Pack Full',
  price: '$29.990'
}];
interface Purchase {
  name: string;
  city: string;
  pack: string;
  price: string;
  minutes: number;
}
function randomItem<T>(arr: T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}
function buildPurchase(): Purchase {
  // Weight the Pack Full slightly higher, as it's the "más elegido"
  const pack = Math.random() < 0.6 ? PACKS[1] : PACKS[0];
  return {
    name: randomItem(NAMES),
    city: randomItem(CITIES),
    pack: pack.name,
    price: pack.price,
    minutes: Math.floor(Math.random() * 12) + 1
  };
}
// Visible duration of each toast, in ms
const VISIBLE_MS = 6000;
export function PurchaseNotification() {
  const [purchase, setPurchase] = useState<Purchase | null>(null);
  const hide = useCallback(() => setPurchase(null), []);
  useEffect(() => {
    let visibleTimer: ReturnType<typeof setTimeout>;
    let nextTimer: ReturnType<typeof setTimeout>;
    const show = () => {
      setPurchase(buildPurchase());
      // Hide after the visible window
      visibleTimer = setTimeout(() => {
        setPurchase(null);
        scheduleNext();
      }, VISIBLE_MS);
    };
    const scheduleNext = () => {
      // Random interval between 40s and 60s
      const delay = 40000 + Math.random() * 20000;
      nextTimer = setTimeout(show, delay);
    };
    // First popup after a short initial delay
    const initialTimer = setTimeout(show, 8000);
    return () => {
      clearTimeout(initialTimer);
      clearTimeout(visibleTimer);
      clearTimeout(nextTimer);
    };
  }, []);
  return <div className="fixed bottom-4 left-4 z-50 pointer-events-none" data-id="element-318">
      <AnimatePresence data-id="element-319">
        {purchase && <motion.div key={`${purchase.name}-${purchase.city}-${purchase.minutes}`} initial={{
        opacity: 0,
        y: 24,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 24,
        scale: 0.96
      }} transition={{
        duration: 0.35,
        ease: 'easeOut'
      }} className="pointer-events-auto w-[300px] max-w-[calc(100vw-2rem)] bg-white rounded-2xl shadow-2xl shadow-slate-900/15 border border-slate-100 p-3 flex items-start gap-3" role="status" aria-live="polite" data-id="element-320">
            <div className="w-10 h-10 rounded-full bg-green-100 flex items-center justify-center flex-shrink-0" data-id="element-321">
              <BadgeCheck className="w-6 h-6 text-green-600" data-id="element-322" />
            </div>

            <div className="flex-grow min-w-0" data-id="element-323">
              <div className="flex items-center gap-1.5 mb-0.5" data-id="element-324">
                <span className="text-[11px] font-bold uppercase tracking-wide text-green-600" data-id="element-325">
                  Compra verificada
                </span>
              </div>
              <p className="text-sm text-slate-800 leading-snug" data-id="element-326">
                <span className="font-bold" data-id="element-327">{purchase.name}</span> de{' '}
                <span className="font-medium" data-id="element-328">{purchase.city}</span> compró el{' '}
                <span className="font-semibold text-brand-700" data-id="element-329">
                  {purchase.pack}
                </span>{' '}
                <span className="text-slate-500" data-id="element-330">({purchase.price})</span>
              </p>
              <p className="text-[11px] text-slate-400 mt-0.5" data-id="element-331">
                hace {purchase.minutes} min · Mercado Pago
              </p>
            </div>

            <button onClick={hide} aria-label="Cerrar notificación" className="flex-shrink-0 text-slate-300 hover:text-slate-500 transition-colors -mt-0.5 -mr-0.5" data-id="element-332">
              <X className="w-4 h-4" data-id="element-333" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}